// extracted by mini-css-extract-plugin
export default {"center":"Spinner_center__bOjxx","spinner":"Spinner_spinner__nuWIb","spinner-aib1d7":"Spinner_spinner-aib1d7__lbpyr"};